import { render } from "./FormularioMaridaje.vue?vue&type=template&id=2dce178e&scoped=true"
import script from "./FormularioMaridaje.vue?vue&type=script&lang=js"
export * from "./FormularioMaridaje.vue?vue&type=script&lang=js"

import "./FormularioMaridaje.vue?vue&type=style&index=0&id=2dce178e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dce178e"]])

export default __exports__